import React from 'react';
import AppShell from '../../components/app-shell/app-shell';  
import PublicShell from '../../components/app-shell/public-shell';
import PublicMarkdown from '../../components/markdown/public-markdown';
import markdown from './podcast.md';

export default function() {
  return (
    <AppShell
      seoTitle="Podcast"
      description="Geek out about letters with some of the calligraphers behind Calligraphy.org as they share tips and learn from top artists."
    >
      <PublicShell>
        <PublicMarkdown markdown={markdown} />
      </PublicShell>
    </AppShell>
  );
}
